import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import React, { useEffect } from "react"
import { Card, Container } from "react-bootstrap";
import { SignInButton } from "../../SignInButton/Component";
import { FixFooterPosition } from "../../../Helpers/helper";

const Content = ({ children, pageContentRef }: { children: React.ReactNode | JSX.Element, pageContentRef?: React.RefObject<HTMLDivElement> }): JSX.Element => {

    useEffect(() => {
        FixFooterPosition();
    }, [window.innerHeight, window.innerWidth]);

    return (
        <Container ref={pageContentRef} id="rdContent">
            <AuthenticatedTemplate>{children}</AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <Container fluid className="unAuth horizontalAlignment">
                    <Card className="verticalAlignment" >
                        <Card.Header>Realize o login para continuar.</Card.Header>
                        <Card.Footer>
                            <Container fluid className="horizontalAlignment fullWidth">
                                <SignInButton />
                            </Container>
                        </Card.Footer>
                    </Card>
                </Container>
            </UnauthenticatedTemplate>
        </Container>
    )
}

export default Content;